import { render } from "./CodeDetailsView.vue?vue&type=template&id=63b94b86"
import script from "./CodeDetailsView.vue?vue&type=script&lang=js"
export * from "./CodeDetailsView.vue?vue&type=script&lang=js"

import "./CodeDetailsView.vue?vue&type=style&index=0&id=63b94b86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__